import store from '@/store';
import gql from 'graphql-tag';
import apolloClient from '../apollo';

const actions = {
  async sendPushNotification({ commit, dispatch }, payload) {
    console.log('sendPushNotification', payload);
    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation sendPushNotification($userId: ID!, $title: String!, $body: String!) {
            sendPushNotification(userId: $userId, title: $title, body: $body)
          }
        `,
        variables: {
          userId: payload.userId,
          title: payload.title,
          body: payload.message,
        },
      });

      dispatch('message', {
        message: 'Push Nachricht gesendet!',
        type: 'success',
        lifetime: 1,
      });
      return response.data.sendPushNotification;
    } catch (error) {
      const message = error.message;
      dispatch('message', {
        message: message,
        type: 'danger',
        lifetime: 1,
      });
    }
  },
};

const mutations = {};

const getters = {};

export default {
  namespaced: false,
  actions,
  mutations,
  getters,
};
